export const LOCATION_UTIL = {
    replaceHref: function (url) {
        window.location.replace(url);
    },
    setHref: function (url) {
        window.location.href = url;
    },
    getHref: function () {
        return window.location.href;
    },
    reloadWindow: function () {
        window.location.reload();
    },
    openWindow: function (url, target) {
        return window.open(url, target);
    },
    closeWindow: function () {
        window.close();
    }
};

/**
 * Modifies or sets a single query param in the current page's URL,
 * and pushes the modified URL to the session history. This means
 * it is considered a new page by the browser's back/forward API.
 * If the new state shouldn't be considered a new page, set the
 * replaceState param to true.
 *
 * @param {String} name
 * @param {String} value
 * @param {Boolean} replaceState
 */
export function updateQueryParameter(name, value, replaceState = false) {
    const query = location.search;
    const params = new URLSearchParams(query);
    params.set(name, value);
    const newQuery = params.toString();

    if (replaceState) {
        window.history.replaceState(null, "", `?${newQuery}`);
    } else {
        window.history.pushState(null, "", `?${newQuery}`);
    }
}

export function removeQueryParameter(name) {
    const query = location.search;
    const params = new URLSearchParams(query);
    params.delete(name);
    const newQuery = params.toString();
    window.history.replaceState(null, "", `?${newQuery}`);
}

/** Creates a map with the query string parameters */
export function getQueryParameters() {
    const queryParameters = {};
    const queryString = location.search.substring(1);
    const re = /([^&=]+)=([^&]*)/g;
    let m;

    while ((m = re.exec(queryString))) {
        queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }

    return queryParameters;
}
